import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';

export class NaceService {
   async getNaces(query?: LocationQuery) {
      const response = await http.get('/nace', { params: query });
      return response.data;
   }

   async getNace() {
      throw Error('Method not implemented');
   }

   async postNace() {
      throw Error('Method not implemented');
   }

   async putNace() {
      throw Error('Method not implemented');
   }

   async deleteNace() {
      throw Error('Method not implemented');
   }
}
